import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import { Provider } from 'react-redux'
import rootReducer from './reducers'
import { hideLegalDialogIfAccepted, navigateToUrlFragment } from './actionCreators'
import App from './components/App.js'
import './index.css'
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react'


/*
	Denna kod finns här för att överrida ett avrundningsfel i
	Number-klassens metod toFixed. Tal som slutar på en femma
	och bara avrundas en decimal avrundas ibland neråt.

	Den första villkorssatsen kollar hur avrundningen fungerar
	och överlagrar toFixed om det går fel.

	I den överlagrande funktionen läggs en liten "nudge" till
	talet som ska avrundas, för att puffa det över kanten att
	avrundas uppåt. (Egentligen blir det fel om man har ett
	tal med tio eller fler nior efer toFixed antal decimaler,
	men detta anses acceptabelt.)
*/
if ((1.005).toFixed(2) !== "1.01") {
	(function (prototype) {
		const toFixed = prototype.toFixed;
		prototype.toFixed = function (fractionDigits) {
			let nudge = Math.pow(10, -1 * (fractionDigits + 10));
			return toFixed.call(this + nudge, fractionDigits);
		}
	}(Number.prototype));
}

async function getSiteId(url) {
	let jsonResult = await fetch(url);
	console.log("url: " + url);
	let data = await jsonResult.json();
	return data
}

async function renderHittaStompunkt() {

	await getSiteId("/matomositeid").then(data => {
		console.log("matomositeid: " + data.matomo.siteId);
		const instance = createInstance({
			urlBase: "/matomo/",
			siteId: data.matomo.siteId, // optional, default value: `1`
			trackerUrl: "/matomo/matomo.php", // optional, default value: `${urlBase}matomo.php`
			srcUrl: "/matomo/matomo.js" // optional, default value: `${urlBase}matomo.js`
		});

		const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

		const store = createStore(
			rootReducer,
			composeEnhancer(applyMiddleware(thunk)),
		);

		store.dispatch(hideLegalDialogIfAccepted())
		store.dispatch(navigateToUrlFragment())


		ReactDOM.render(
			<Provider store={store}>
				<MatomoProvider value={instance}>
					<App />
				</MatomoProvider>
			</Provider>,
			document.getElementById('react-root')
		);
	})
}

renderHittaStompunkt()






// WEBPACK FOOTER //
// ./src/index.js